/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import { get } from 'lodash';
import { Mapper, PresenterType } from '../../types';
import { flatByAttribute, personDropdownExtraInfo } from '../../utils';
import { gqlPersonFilterByNameOrEmail } from '../../queryFilter';
import { Layout } from '../../constants';

export default {
  DROPDOWN: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: Layout.Columns.Half,
    extraInfo: {
      submissionDataParser: flatByAttribute('value'),
      editValueParser: data => ({
        value: data.value,
        label: data.value,
      }),
    },
  },
  MULTI: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: {
      ...Layout.Columns.Half,
      presenterAttributes: {
        multiple: true,
      },
    },
    extraInfo: {
      submissionDataParser: flatByAttribute('value'),
      editValueParser: data =>
        get(data, 'value', []).map((value: string) => ({
          value: value,
          label: value,
        })),
    },
  },
  MAP_PERSON: {
    presenter: PresenterType.DropdownFormPresenter,
    renderInfo: Layout.Columns.Half,
    extraInfo: {
      ...personDropdownExtraInfo,
      dropdownOptionsParser: data =>
        get(data, 'dropdownOptions.edges', []).map(edge => ({
          value: edge.node.email.value,
          label: edge.node.name.value,
          role: edge.node.userRole.value || 'No role',
          id: edge.node.id,
        })),
      editValueParser: data => {
        const val = get(data, 'value');
        return !val
          ? val
          : {
              value: val.email.value,
              label: val.name.value,
              role: val.userRole.value || 'No role',
              id: val.id,
            };
      },
      optionsQueryFilter: (searchValue: string) => {
        return searchValue ? JSON.stringify(gqlPersonFilterByNameOrEmail(searchValue)) : null;
      },
    },
  },
  TEXT: {
    presenter: PresenterType.InputFormPresenter,
    renderInfo: Layout.Columns.Half,
  },
  RICH_TEXT: {
    presenter: PresenterType.RichTextFormPresenter,
    renderInfo: Layout.Columns.Full,
  },
  DATE: {
    presenter: PresenterType.DateFormPresenter,
    renderInfo: Layout.Columns.Half,
  },
  CHECKBOX: {
    presenter: PresenterType.CheckboxFormPresenter,
    renderInfo: Layout.Columns.Half,
  },
  FLOAT: {
    presenter: PresenterType.InputFormPresenter,
    renderInfo: {
      ...Layout.Columns.Half,
      presenterAttributes: {
        type: 'number',
      },
    },
    extraInfo: {
      submissionDataParser: val => (val === '' ? '' : +val),
    },
  },
  INT: {
    presenter: PresenterType.InputFormPresenter,
    renderInfo: {
      ...Layout.Columns.Half,
      presenterAttributes: {
        type: 'number',
      },
    },
    extraInfo: {
      submissionDataParser: val => (val === '' ? '' : +val),
    },
  },
} as Mapper;
